import { useQuery } from 'react-query';
import { LimitedSchemaQueryOptions } from '@frontend/react-query-helpers';
import { SchemaDigitalForms } from '../../service';
import { IO } from '../../types';
import { defaultOptions } from '../config';
import { requestKeys } from '../keys';

export const useGetBannerStatus = <E = unknown, T = IO.GetBannerStatus['output']>(
  req: IO.GetBannerStatus['input'],
  options?: LimitedSchemaQueryOptions<IO.GetBannerStatus, E, T>
) => {
  const queryKey = requestKeys.getBannerStatus(req);

  const query = useQuery({
    queryKey,
    queryFn: () => SchemaDigitalForms.GetBannerStatus(req),
    ...defaultOptions,
    ...options,
  });

  return {
    queryKey,
    ...query,
  };
};
